import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["indicator", "save"]
  connect() { this.dirty = false; this.mark = this.mark.bind(this)
    this.element.addEventListener("input", this.mark)
    this.element.addEventListener("change", this.mark)
    this.element.addEventListener("cocoon:after-insert", this.mark)
    this.element.addEventListener("cocoon:after-remove", this.mark) }
  mark() { if (this.dirty) return; this.dirty = true
    this.indicatorTarget.classList.remove("hidden") }
  disconnect() { this.element.removeEventListener("input", this.mark)
    this.element.removeEventListener("change", this.mark) }
}
